

















import { Component, Vue, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { LoginUser } from '@/types/user'
import { MediaComponentProps } from '@/components/common/videoCallRoom/VideoCallRoomContainer.vue'

@Component({
  components: {
    VideoCallRoomMaximum: () =>
      import('@/components/common/videoCallRoom/VideoCallRoomMaximum.vue'),
    VideoCallRoomMinumum: () =>
      import('@/components/common/videoCallRoom/VideoCallRoomMinimum.vue')
  }
})
export default class VideoCallRoom extends Vue {
  @Prop(Object) user!: LoginUser
  @Prop(Array) participants!: Array<MediaComponentProps>

  @Prop({ type: Object, default: null })
  mainScreenParticipant!: MediaComponentProps | null

  @Prop({ default: '' }) occupationCode!: string
  @Prop({ default: '' }) occupationShortName!: string

  $store!: ExStore

  get minimized() {
    return this.$store.getters['videoCallRoom/minimized']
  }

  async handleHangUp() {
    this.$emit('hangup')
  }

  handleChangeMainScreen(id: number) {
    this.$emit('changeMainScreen', id)
  }
}
